export default __webpack_public_path__ + "static/media/lucide_edit.6981f22e.svg";